import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'formly-field-chips',
  template: `
    <div [id]="elementId + '_chips'">
      <input type="hidden" [id]="elementId" class="wcag-visuallyhidden">
      <div class="mb-2">
        <ng-container *ngFor="let item of list; let i = index">
          <div class="badge badge-primary badge-tag simple-tag">
          {{ item }}
            <button type="button" class="close" aria-label="Close / Delete" (click)="remove(i)">
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </ng-container>
      </div>

      <div class="row">
        <div class="input-group mb-3 col-6">
          <input type="text"
                 class="form-control"
                 [(ngModel)]="newItem"
                 [class.ng-invalid]="formControl.invalid"
                 [formlyAttributes]="field"
                 [placeholder]="placeholder"
                 [attr.aria-label]="newItem || 'New item Value'"
                 [attr.maxLength]="maxLength ? maxLength : null">
            <div class="input-group-append">
              <button class="btn btn-secondary" type="button" (click)="addItem()" aria-label="Add item">{{ buttonText }}</button>
            </div>
        </div>
      </div>
    </div>
  `,
})
export class FormlyFieldChipsComponent extends FieldType implements OnInit {

  public placeholder: string;
  public label: string;
  public translatePrefix;
  public newItem;
  public buttonText;
  public maxLength;

  private _list = [];

  constructor(
    private translateService: TranslateService,
  ) {
    super();
  }

  get list() {
    return this._list;
  }

  set list(val) {
    this._list = val;
    this.propagateChange(this._list);
  }

  propagateChange(val) {
    this.model[this.key as string] = val;
    if (this.props.change) {
      this.props.change(this.field, val);
    }
  }

  ngOnInit() {
    this.translatePrefix = this.props.translatePrefix ? `${ this.props.translatePrefix }.` : '';
    this.props.placeholder && (this.placeholder = this.translateService.instant(`${ this.translatePrefix }${ this.props.placeholder }`));
    this.props.label && (this.props.label = this.translateService.instant(`${ this.translatePrefix }${ this.props.label }`));
    this.props.buttonText && (this.buttonText = this.translateService.instant(`${ this.translatePrefix }${ this.props.buttonText }`));
    this.maxLength = this.props.maxLength ? this.props.maxLength : null;
    this.list = this.model[this.key as string] || [];
  }

  get elementId(): string {
    if (this.field.id && this.field.id.includes('formly_')) {
      let prefix = this.form['id'];

      // check if in repeat section
      if (!prefix && this.field.parent.parent && this.field.parent.parent.parent && this.field.parent.parent.parent.type === 'repeat') {
        const cnt = this.field.parent.parent.key;
        prefix = `${this.field.parent.parent.parent['id']}_${cnt}`;
      }

      return `${prefix ? prefix + '_' : ''}${(this.field.key as string).replace('.', '_')}`;
    } else {
      return this.field.id;
    }
  }

  addItem() {
    if (this.newItem && this.newItem.trim() !== '') {
      this.list = [...this.list, this.newItem];
      this.newItem = null;
    }
  }

  remove(index) {
    if(this.form && this.form.disabled){
      return;
    }
    this.list.splice(index, 1);
    this.propagateChange(this.list);
  }

}
